/* KumKum Noveltys — premium interactions */
(function () {
  'use strict';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function toast(msg, withCart) {
    var t = document.querySelector('.kk-toast');
    if (!t) { t = document.createElement('div'); t.className = 'kk-toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
    t.innerHTML = '<span>' + msg + '</span>' + (withCart ? '<a class="kk-btn kk-btn--gold" href="' + root + 'cart">View Cart</a>' : '');
    t.classList.add('is-on');
    clearTimeout(t._h);
    t._h = setTimeout(function () { t.classList.remove('is-on'); }, 4500);
  }
  function refreshBubble() {
    fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (c) {
      var icon = document.getElementById('cart-icon-bubble');
      if (!icon) return;
      var b = icon.querySelector('.cart-count-bubble');
      if (!b) { b = document.createElement('div'); b.className = 'cart-count-bubble'; icon.appendChild(b); }
      b.innerHTML = '<span aria-hidden="true">' + c.item_count + '</span>';
    }).catch(function () {});
  }
  function addItems(items) {
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { if (!r.ok) throw r; return r.json(); });
  }

  document.addEventListener('submit', function (e) {
    var f = e.target.closest && e.target.closest('.kk-card__form');
    if (!f) return;
    e.preventDefault();
    var btn = f.querySelector('button');
    var label = btn.textContent;
    btn.textContent = 'Adding…';
    addItems([{ id: Number(f.querySelector('[name=id]').value), quantity: 1 }])
      .then(function () { toast('✓ Added to your cart', true); refreshBubble(); })
      .catch(function () { f.submit(); })
      .finally(function () { btn.textContent = label; });
  });

  document.addEventListener('click', function (e) {
    var c = e.target.closest('[data-kk-copy]');
    if (!c) return;
    e.preventDefault();
    var code = c.getAttribute('data-kk-copy');
    var done = function () {
      c.classList.add('is-copied');
      var s = c.querySelector('.kk-code__hint');
      if (s) s.textContent = 'Copied ✓';
      toast('Code ' + code + ' copied — apply it at checkout');
    };
    if (navigator.clipboard) navigator.clipboard.writeText(code).then(done, done); else done();
  });

  function initHero(el) {
    if (el._kk) return; el._kk = 1;
    var slides = el.querySelectorAll('.kk-hero__slide');
    var dots = el.querySelectorAll('.kk-hero__dot');
    if (slides.length < 2) return;
    var i = 0, timer, speed = (parseInt(el.dataset.speed, 10) || 6) * 1000;
    function go(n) {
      slides[i].classList.remove('is-active'); if (dots[i]) dots[i].classList.remove('is-active');
      i = (n + slides.length) % slides.length;
      slides[i].classList.add('is-active'); if (dots[i]) dots[i].classList.add('is-active');
    }
    function stop() { clearInterval(timer); }
    function play() { stop(); timer = setInterval(function () { go(i + 1); }, speed); }
    dots.forEach(function (d, n) { d.addEventListener('click', function () { go(n); play(); }); });
    var p = el.querySelector('.kk-hero__prev'), nx = el.querySelector('.kk-hero__next');
    if (p) p.addEventListener('click', function () { go(i - 1); play(); });
    if (nx) nx.addEventListener('click', function () { go(i + 1); play(); });
    el.addEventListener('mouseenter', stop); el.addEventListener('mouseleave', play);
    var x0 = null;
    el.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    el.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) { go(dx < 0 ? i + 1 : i - 1); play(); }
      x0 = null;
    });
    el.addEventListener('shopify:block:select', function (e) { var n = Array.prototype.indexOf.call(slides, e.target); if (n > -1) { stop(); go(n); } });
    play();
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('.kk-tabs__btn');
    if (!t) return;
    var wrap = t.closest('.kk-tabs');
    wrap.querySelectorAll('.kk-tabs__btn').forEach(function (b) { b.classList.toggle('is-active', b === t); b.setAttribute('aria-selected', b === t); });
    wrap.querySelectorAll('.kk-tabs__panel').forEach(function (p) { p.hidden = p.id !== t.getAttribute('aria-controls'); });
  });

  function initCombo(el) {
    if (el._kk) return; el._kk = 1;
    var need = parseInt(el.dataset.need, 10) || 2;
    var picked = [];
    var bar = el.querySelector('.kk-combo__bar');
    var count = el.querySelector('[data-kk-count]');
    var btn = el.querySelector('[data-kk-combo-add]');
    var slots = el.querySelectorAll('.kk-combo__slot');
    if (bar && bar.parentNode !== document.body) document.body.appendChild(bar);
    function find(key) { var at = -1; picked.forEach(function (p, n) { if (p.key === key) at = n; }); return at; }
    function render() {
      count.textContent = picked.length;
      slots.forEach(function (s, n) {
        var p = picked[n];
        s.innerHTML = p ? '<img src="' + p.img + '" alt="">' : '<span>+</span>';
        s.classList.toggle('is-filled', !!p);
      });
      btn.disabled = picked.length < need;
      btn.textContent = picked.length < need ? 'Pick ' + (need - picked.length) + ' more' : 'Add Combo to Cart';
      bar.classList.toggle('is-on', picked.length > 0);
      document.body.classList.toggle('kk-bar-on', picked.length > 0);
      el.querySelectorAll('[data-kk-pick]').forEach(function (c) {
        var b = c.querySelector('.kk-combo__select');
        if (b) b.textContent = c.classList.contains('is-picked') ? '✓ Selected' : 'Select';
      });
    }
    el.addEventListener('change', function (e) {
      var sel = e.target.closest('[data-kk-size]');
      if (!sel) return;
      sel.classList.remove('is-error');
      var card = sel.closest('[data-kk-pick]');
      var at = find(card.getAttribute('data-kk-pick'));
      if (at > -1) picked[at].id = sel.value;
    });
    el.addEventListener('click', function (e) {
      var tg = e.target.closest('[data-kk-toggle]');
      if (!tg) return;
      var card = tg.closest('[data-kk-pick]');
      if (!card) return;
      e.preventDefault();
      var key = card.getAttribute('data-kk-pick');
      var at = find(key);
      if (at > -1) { picked.splice(at, 1); card.classList.remove('is-picked'); render(); return; }
      var sel = card.querySelector('[data-kk-size]');
      var vid = sel ? sel.value : card.getAttribute('data-kk-vid');
      if (!vid) { toast('Please choose your waist size first'); if (sel) { sel.focus(); sel.classList.add('is-error'); } return; }
      if (picked.length >= need) {
        var old = picked.shift();
        var oc = el.querySelector('[data-kk-pick="' + old.key + '"]');
        if (oc) oc.classList.remove('is-picked');
      }
      picked.push({ key: key, id: vid, img: card.getAttribute('data-kk-img') });
      card.classList.add('is-picked');
      render();
    });
    btn.addEventListener('click', function () {
      if (picked.length < need) return;
      btn.textContent = 'Adding…';
      addItems(picked.map(function (p) { return { id: Number(p.id), quantity: 1 }; }))
        .then(function () { window.location = root + 'cart'; })
        .catch(function () { toast('Could not add — please try again'); render(); });
    });
    render();
  }

  function initSticky() {
    var bar = document.querySelector('.kk-sticky');
    var main = document.querySelector('.product-form__submit');
    if (!bar || !main || bar._kk) return; bar._kk = 1;
    document.body.appendChild(bar);
    bar.querySelector('button').addEventListener('click', function () { main.scrollIntoView({ behavior: 'smooth', block: 'center' }); setTimeout(function () { main.click(); }, 350); });
    new IntersectionObserver(function (en) {
      var on = !en[0].isIntersecting && en[0].boundingClientRect.top < 0;
      bar.classList.toggle('is-on', on);
      if (window.innerWidth < 750) document.body.classList.toggle('kk-bar-on', on);
    }).observe(main);
  }
  function initDelivery() {
    document.querySelectorAll('[data-kk-eta]').forEach(function (el) {
      var r = el.getAttribute('data-kk-eta').split(',');
      var f = function (d) { var x = new Date(); x.setDate(x.getDate() + Number(d)); return x.toLocaleDateString('en-IN', { day: 'numeric', month: 'short' }); };
      el.textContent = f(r[0]) + ' – ' + f(r[1]);
    });
  }
  function initReveal() {
    var els = document.querySelectorAll('.kk-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('is-in'); io.unobserve(x.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }
  function boot() {
    document.querySelectorAll('.kk-hero').forEach(initHero);
    document.querySelectorAll('.kk-combo').forEach(initCombo);
    initSticky(); initDelivery(); initReveal();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
